import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {AddContactCommand} from "@shared/commands/contacts.command";
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {CommandService} from "@core/services/command.service";
import {QueryProvider} from "@shared/queries/query-provider";
import {IQueryState} from "@shared/store/reducers/query.reducer";
import {Store} from "@ngrx/store";
import {PlatformCommand} from "@shared/commands/command-base";

@Component({
    standalone: false,
    selector: 'particle-conversation-add-contact',
  templateUrl: './conversation-add-contact.component.html',
  styleUrls: ['./conversation-add-contact.component.scss']
})
export class ConversationAddContactComponent implements OnInit {
  addContactDetails: any;
  queryKey: string;
  @Output() addContactAction: EventEmitter<any> = new EventEmitter<any>();

  constructor(private fuseSplashScreenService: FuseSplashScreenService,
              private queryStore: Store<IQueryState>,
              public commandService: CommandService) {
    this.queryKey = 'AllContactList';
  }

  ngOnInit() {
  }

  onContactValueChanged(event) {
    console.log(event);
    this.addContactDetails = event;
  }

  onAddContact() {
    const addContactCommand = new PlatformCommand('AddContactCommand', 'ContactsApi');
    addContactCommand.fieldValues['FirstName'] = this.addContactDetails.value.firstname;
    addContactCommand.fieldValues['LastName'] = this.addContactDetails.value.lastname;
    addContactCommand.fieldValues['Email'] = this.addContactDetails.value.email?.toLowerCase();
    addContactCommand.fieldValues['Phone'] = this.addContactDetails.value.phone;
    addContactCommand.fieldValues['Title'] = '';
    addContactCommand.fieldValues['Message'] = this.addContactDetails.value.message;
    addContactCommand.fieldValues['FirmName'] = this.addContactDetails.value.firmName;
    addContactCommand.fieldValues['FirmCountry'] = this.addContactDetails.value.firmCountry;
    addContactCommand.projectId = '[PROJECT_ID]';
    addContactCommand.isCamelCase = true;
    this.fuseSplashScreenService.show();
    this.commandService.executePlatformCommand(addContactCommand).subscribe(value => {
      console.log(value);
      this.fuseSplashScreenService.hide();
     //  QueryProvider.invokeQuery(this.queryStore, this.queryKey, {'[ITEM_ID]': ''});
      this.addContactAction.emit('addContactDone');
    }, error => {
      this.fuseSplashScreenService.hide();
      console.log(error);
    });
  }

  onCancelAddContact() {
    console.log('this.cacel add contact');
    this.addContactAction.emit('addContactCancel');
  }

}
